import React from 'react';
import { renderDateTime, renderNumber } from '../../../helpers/HelperMethods';
import ConnectorsList from './ConnectorsList';
import { PowerAppBaseType } from '../../../GlobalConst/globalEnums';

const PowerAppUsage = ({app}) => {

    return (
        <div style={{padding: 12}}>
            <div>
                <label className='textField'>Last modification: </label>
                <span style={{color: 'blue'}}>{renderDateTime(app.modified)}</span>
            </div>
            <div>
                <label className='textField'>Last usage date: </label>
                <span style={{color: 'blue'}}>{renderDateTime(app.lastLaunched)}</span>
            </div>
            {
                app.type === PowerAppBaseType.powerApp
                ? <div style={{  width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{flex: 1}}>
                        <label className='textField'>App visitors (last 3 months): </label>
                        <span style={{color: 'blue'}}>{renderNumber(app.usageSize)}</span>
                    </div>
                    <div style={{flex: 1}}>
                        <label className='textField'>App unique visitors (last 3 months): </label>
                        <span style={{color: 'blue'}}>{renderNumber(app.uniqueUsageSize)}</span>
                    </div>
                </div>
                : <div>
                    <label className='textField'>Flow runs (last 3 months): </label>
                    <span style={{color: 'blue'}}>{renderNumber(app.usageSize)}</span>
                </div>
            }
            <div style={{ border: '1px solid rgb(138, 136, 134)',  margin: 10, padding: '4px 10px 10px 2px'}}>
                <label className='textField'>Connectors:</label>
                <ConnectorsList app={app} />
            </div>
        </div>
    )
}

export default PowerAppUsage;


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/PowerAppUsage.js